import type { LineItem } from '../../../../../codegen/types';
import { calculateDiscount } from '../../../../../utils/calculateDiscount';
import { getAmount } from '../../../../../utils/currencyHelper';
import { addToStorageArray, createStorageKey, getItem, removeItem } from '../../../../../utils/storage';
import { getAlgoliaProductIndex } from '../../../searchClient';
import { sendAddedToCartAfterSearchEvent, sendConvertedEvent } from '../../events';

export const sendAlgoliaInsightsAddToCartEvent = (product: LineItem, locale: string, previousURL: string) => {
  const algoliaIndex = getAlgoliaProductIndex(locale);
  const isFromPLP = /-c/.test(previousURL); // true if user comes from PLP
  const isFromSearch = Boolean(getItem('isFromSearch', true, 'sessionStorage')); // true if user comes from search
  const objectID = product.productKey ?? '';
  const queryID = getItem('queryID') as string;
  const unitPrice = Number(getAmount(product.price.value.centAmount));
  const totalPrice = Number(getAmount(product.totalPrice.centAmount));
  const { quantity } = product;
  const discount = calculateDiscount(unitPrice, totalPrice, quantity);
  const getStorageKey = (baseKey: string) => createStorageKey(baseKey, locale);
  const cartItemsDataStorageKey = getStorageKey('cartItemsData');

  if (isFromPLP || isFromSearch) {
    sendAddedToCartAfterSearchEvent({
      eventName: 'PDP: Product Added to Cart after Search',
      index: algoliaIndex,
      objectID,
      queryID,
      objectData: {
        price: unitPrice,
        quantity: product.quantity,
        ...(discount && { discount }),
      },
      value: getAmount(product.totalPrice.centAmount),
      currency: product.totalPrice.currencyCode,
    });
    addToStorageArray(cartItemsDataStorageKey, { queryID, objectID }, 'sessionStorage');
    removeItem('isFromSearch', 'sessionStorage');
  } else {
    sendConvertedEvent({ eventName: 'PDP: Product Added to Cart', index: algoliaIndex, objectID });
  }
};
